import type { Attachment } from '@billy/design-system'

import { EInvoiceStatus } from '@features/eInvoicing/constants'

import { getAttachmentEInvoiceStatus } from './getAttachmentEInvoiceStatus'

const BLOCKED_E_INVOICE_STATUSES = [EInvoiceStatus.Refused, EInvoiceStatus.Suspended, EInvoiceStatus.Disputed]

export const isAttachmentBlocked = (attachment: Attachment): boolean => {
  const status = getAttachmentEInvoiceStatus(attachment)

  return status !== null && BLOCKED_E_INVOICE_STATUSES.includes(status)
}
